import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { isAdminAuthor } from '../utils/adminUtils';
import { LoadingState } from './ui';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { author, token, loading } = useAuth();

  if (loading) {
    return <LoadingState fullPage label="Verification des droits admin..." />;
  }

  if (!author || !token || !isAdminAuthor(author)) {
    return <Navigate to="/unauthorized-access" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
